export default "__VITE_ASSET__C1hhty2i__"